/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import ReactDOM from "react-dom";
import { Main } from "./components/Main";
import { ModelProvider } from "./providers/ModelProvider";
import { Model_FPI_MSP_2020_05_Spec } from "./models/fpi-msp-2020-05";

window.onload = () => {

	const modelProvider = new ModelProvider();

	modelProvider.register(Model_FPI_MSP_2020_05_Spec);

	ReactDOM.render(
		<Main modelProvider={modelProvider} />
	, document.getElementById("app-container"));

};
